<script setup lang="ts">
import { useChatStore } from '../stores/chatStore';

const chatStore = useChatStore();
const config = useRuntimeConfig();
const { isMobile } = useDevice();
const { sendToParent } = useParentMessaging();

/**
 * チャット画面表示
 */
const startChat = () => {
    let chatMode = "openChat";
    if (chatStore.windowExtend || isMobile) {
        chatMode = "largeChat";
    }

    document.body.style.display = "none";
    sendToParent({ mode: chatMode });
    setTimeout(() => {
        chatStore.windowClosed = false;
        document.body.style.display = "block";
    }, 200);
}

/**
 * チャット起動アイコン削除（小さい起動アイコン表示）
 */
const removeStartChat = () => {
    document.body.style.display = "none";
    sendToParent({ mode: "smallIcon" });
    setTimeout(() => {
        chatStore.isDspStartChat = false;
        document.body.style.display = "block";
    }, 200);
}
</script>

<template>
    <div>
        <ClientOnly>
            <div class="aichat-icon" v-show="chatStore.windowClosed && chatStore.isDspStartChat">
                <button type="button" @click="startChat" class="">
                    <img :src="chatStore.createUrl(true, 'images/icon_start_chat.png')"
                        :alt="config.public.title + '起動'" title="" class="" />
                </button>
                <button type="button" @click="removeStartChat" class="aichat-icon-close">
                    <img :src="chatStore.createUrl(true, 'images/icon_start_chat_close.svg')" class=""
                        :alt="config.public.title + '起動アイコンを最小化'" title="" />
                </button>
            </div>
            <button type="button" @click="startChat" class="aichat-icon-small z-[10100]"
                v-show="chatStore.windowClosed && !chatStore.isDspStartChat">
                <img :src="chatStore.createUrl(true, 'images/icon_start_chat_small.png')"
                    :alt="config.public.title + '起動'" title="" class="" />
            </button>
        </ClientOnly>
    </div>
</template>